export default __webpack_public_path__ + "static/media/teamfone-logo-white.1858fcea.svg";